import { IconButton, Tooltip, Typography, Paper, Grid } from "@material-ui/core"
import GetAppIcon from "@material-ui/icons/GetApp"
import DeleteOutline from "@material-ui/icons/DeleteOutline"
import React, { FunctionComponent } from "react"
import styles from "./PromptsTableToolbar.module.scss"
import { ConfirmationDialog } from "../../components/ConfirmationDialog"
import { useNotification } from "../../common/hooks/useNotification"

interface PromptsTableToolbarProps {
    numSelected: number
    onDownload: () => void
    onDelete: () => Promise<{ deleteSuccesses: number; deleteErrors: number }>
    refreshTable: () => void
}
export const PromptsTableToolbar: FunctionComponent<PromptsTableToolbarProps> = props => {
    const { numSelected, onDownload, refreshTable, onDelete } = props
    const [modalOpen, setModalOpen] = React.useState(false)
    const [deleteLoading, setDeleteLoading] = React.useState(false)
    const { notifySuccess, notifyError } = useNotification()

    const handleDelete = async () => {
        setDeleteLoading(true)
        onDelete().then(({ deleteSuccesses, deleteErrors }) => {
            setDeleteLoading(false)
            setModalOpen(false)
            if (deleteSuccesses)
                notifySuccess(`Successfully Deleted ${getNPromptText(deleteSuccesses)}`)
            if (deleteErrors) notifyError(`Error Deleting ${getNPromptText(deleteErrors)}`)
            refreshTable()
        })
    }

    function getNPromptText(n: number) {
        if (n === 1) return `${n} Prompt`
        return `${n} Prompts`
    }

    return (
        <>
            <div className={styles.PromptsTableToolbar} data-testid="toolbar">
                {numSelected > 0 && (
                    <Paper className={styles.PromptsTableToolbar__tools}>
                        <Typography variant="subtitle1" component="div">
                            {numSelected} selected
                        </Typography>
                        <Grid container direction="row">
                            <Grid item>
                                <Tooltip title="Download">
                                    <IconButton
                                        onClick={onDownload}
                                        id="toolbarDownloadBtn"
                                        data-testid="toolbarDownloadBtn"
                                    >
                                        <GetAppIcon />
                                    </IconButton>
                                </Tooltip>
                            </Grid>
                            <Grid item>
                                <Tooltip title="Delete">
                                    <IconButton
                                        id="toolbarDeleteBtn"
                                        data-testid="toolbar-delete-btn"
                                        onClick={() => setModalOpen(true)}
                                    >
                                        <DeleteOutline />
                                    </IconButton>
                                </Tooltip>
                            </Grid>
                        </Grid>
                    </Paper>
                )}
                <ConfirmationDialog
                    open={modalOpen}
                    onClose={() => setModalOpen(false)}
                    onConfirm={() => handleDelete()}
                    title={`Delete ${getNPromptText(numSelected)}?`}
                    contentText={
                        "Prompts cannot be restored after being deleted, are you sure you want to remove these prompts?"
                    }
                    loading={deleteLoading}
                />
            </div>
        </>
    )
}
